import files from './files/index'
import base from './base'

export default (config) => {
  // order is important
  config = files(config)
  config = base(config)

  return config
}
